export default "__VITE_ASSET__8b76222f__"